import React from 'react';
import { motion } from 'framer-motion';
export const OpeningHook = () => {
  return <section className="py-20 bg-cream-dark" data-id="element-186">
      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-188">
          <p className="text-xl md:text-2xl leading-relaxed text-charcoal mb-8 font-medium" data-id="element-189">
            Te levantas a las 7 AM y ya te sientes cansado. Te miras al espejo y
            notas esa hinchazón en la cara y el abdomen que parece no irse con
            nada. No es solo "la edad" y no es solo falta de ejercicio.
          </p>
          <p className="text-lg md:text-xl leading-relaxed text-charcoal-light" data-id="element-190">
            Tu cuerpo está atrapado en un ciclo de inflamación crónica. A los
            40+, las reglas del juego han cambiado y lo que antes te funcionaba,
            hoy solo te estresa más.
          </p>
        </motion.div>
      </div>
    </section>;
};